import ResultsList from './ResultsList';

export default ResultsList;
export type { ElectionOutcome, ResultRow, ResultRowKind } from './ResultsList';
